import React, { useState } from 'react';
import './UserDropDown.css';
import Avatar from '../Avatar/Avatar';
import Button from '../Button/Button';
import Modal from '../Modal/Modal';

const UserDropDown = (
  { 
    email, 
    businessTokenMappingData = [],
    show, 
    onHide, 
    onLogout,
    enableCopy = true, // Copy Token
    enableView = false, // View Token
    size = 'sm', // sm, lg, xl
    position = 'center', // 'center', 'top', 'bottom', 'top-start', 'top-end', 'bottom-start', 'bottom-end'
    style = {},
    variant = 'desktop' // 'desktop', 'mobile'
  }) => {

  const [copiedToken, setCopiedToken] = useState(null);
  const [visibleToken, setVisibleToken] = useState(null);

  // handle copy text to clipboard
  const handleCopyText = (e, text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text)
        .then(() => {
          setCopiedToken(text);
          setTimeout(() => setCopiedToken(null), 300); // Reset copied state after 1.5 seconds
        })
        .catch((err) => {
          console.error('Failed to copy text: ', err);
        });
    } else {
      console.warn('Clipboard API not supported');
      // Fallback method, e.g., using a temporary textarea element
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        setCopiedToken(text);
        setTimeout(() => setCopiedToken(null), 300);
      } catch (err) {
        console.error('Fallback copy failed: ', err);
      }
      document.body.removeChild(textarea);
    }
  };

  const handleVisibility = (token) => {
    // clicking same token then close
    if (visibleToken === token) {
      setVisibleToken(null);
    }
    else {
      setVisibleToken(token);
    }
  }

  return (
    <Modal size={size} show={show} onHide={onHide} style={style} position={position}>
      <Modal.Body>
        <div className="profile-menu-container">
          {/* Main Menu Container */}
          <div className='profile-menu'>
            {/* Header for desktop view */}
            <div className='menu-header'>
              {variant === 'desktop' && (
                <>
                  <div className={`menu-button-header-container-${variant}`}>
                    <Button
                      size="sm"
                      variant="ghost"
                      onClick={onHide}
                      className={`header-button-${variant}`}
                    >
                      &times;
                    </Button>
                  </div>
                  <h2 className={`email-header-${variant}`}>{email || 'Email Address'}</h2>
                  <Avatar email={email} />
                </>
              )}

              {/* Header for desktop view */}
              {variant === 'mobile' && (
                <>
                  <div className={`email-avatar-container-${variant}`}>
                    <Avatar email={email} className='avatar-mobile'/>
                    <div className={`email-header-container-${variant}`}>
                      <h2 className={`email-header-${variant}`}>{email || 'Email Address'}</h2>
                    </div>
                  </div>
                  <div className={`menu-button-header-container-${variant}`}>
                    <Button
                      size="sm"
                      variant="ghost"
                      onClick={onHide}
                      className={`header-button-${variant}`}
                    >
                      &times;
                    </Button>
                  </div>
                </>
              )}
            </div>

            {/* Divider */}
            <div className="divider"></div>

            {/* Business token table */}
            <div className='business-token-table-container'>              
              <table className='business-token-table'>
                <thead>
                  <tr>
                    <th className='business-token-menu-header'>
                      BUSINESS
                    </th>
                    <th className='business-token-menu-header'>
                      TOKEN                  
                    </th>
                  </tr>
                </thead>
                <tbody>
                {
                  businessTokenMappingData.map(data => (
                    data &&
                    <React.Fragment key={`${data.business}-${data.token}`}>
                    {/* Enabling token copy */}
                    {enableCopy && (
                    <tr>
                      <td className='business-token-table-column'>
                        {data?.business.charAt(0).toUpperCase() + data?.business.slice(1).toLowerCase()}
                      </td>

                      <td className='business-token-table-column'>
                        <button
                          className='business-token-table-btn-copy'
                          title="Copy this token"
                          onClick={(e) => handleCopyText(e, data.token)}
                          >
                          <i className="fa-solid fa-copy fa-lg" style={{ color: copiedToken === data.token ? 'black' : '#E8E8E8'}}></i>
                        </button>
                      </td>
                    </tr>
                    )}

                    {enableView && (
                      <>
                      <tr>
                        <td className='business-token-table-column'>
                          {data?.business.charAt(0).toUpperCase() + data?.business.slice(1).toLowerCase()}
                        </td>

                        <td className='business-token-table-column'>
                          <button
                            className='business-token-table-btn-copy'
                            title="Copy this token"
                            onClick={(e) => handleVisibility(data.token)}
                            >
                            <i className= {visibleToken === data.token ? "fa-regular fa-eye-slash fa-lg" : "fa-regular fa-eye fa-lg" } style={{color: 'white'}}></i>
                          </button>
                        </td>
                      </tr>

                      <tr>
                        <td colSpan="2" className='business-token-view-box'>
                          <div className={`collapsible ${visibleToken === data.token ? 'visible' : ''}`}>
                            <div className="token-box">
                              <div className="token-header">
                                <button
                                  className='business-token-table-btn-copy'
                                  title="Copy this token"
                                  onClick={(e) => handleCopyText(e, data.token)}
                                  >
                                  <i className="fa-solid fa-copy fa-lg" style={{ color: copiedToken === data.token ? 'black' : '#E8E8E8'}}></i>
                                </button>
                              </div>
                              <div className="token-value">{data.token}</div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </>
                    )}

                  </React.Fragment>
                  ))
                }
                </tbody>
              </table>
            </div>

            {/* Bottom Divider */}
            <div className="divider"></div>

            {/* Sign Out Button */}
            <div className="sign-out-container">
              <Button variant='ghost'
                onClick={onLogout}
              >
                Sign out
              </Button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UserDropDown;